import { render, staticRenderFns } from "./StartupCardForm.vue?vue&type=template&id=a6b27c00"
import script from "./StartupCardForm.vue?vue&type=script&lang=js"
export * from "./StartupCardForm.vue?vue&type=script&lang=js"
import style0 from "./StartupCardForm.vue?vue&type=style&index=0&id=a6b27c00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports